import styles from "./VerifyOtp.module.css";
import ModalView from "@modals/modalview/ModalView";
import { environment } from "@environments/environment";
import {
  readStoredPhoneCredentials,
  useOtpLogin,
  useOtpInput,
  useLoginModals,
} from "@hooks/login";

function VerifyOtp({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  const { goToEditPhone } = useLoginModals();
  const phoneData = readStoredPhoneCredentials();

  const phoneNumber = phoneData?.number ?? "";
  const countryCode = phoneData?.dialCode ?? "+91";
  const displayNumber = `${countryCode}${phoneNumber}`;

  const {
    error,
    setError,
    isVerifying,
    verifyOtp,
    resendOtp,
    captchaRef,
    timeLeft,
    canResend,
    formatTime,
  } = useOtpLogin({
    mobileNumber: phoneNumber,
    isdCode: countryCode,
    phone: phoneData ?? undefined,
    enabled: isOpen,
    startTimerOnMount: true,
    onAuthenticated: onClose,
  });

  const { otp, isComplete, inputsRef, getOtpString, handleInputChange, handleKeyDown } =
    useOtpInput();

  if (!phoneData) {
    return null;
  }

  return (
    <>
      {isOpen && (
        <div
          ref={captchaRef}
          className="g-recaptcha"
          data-sitekey={environment.captchaSiteKey}
          data-size="invisible"
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: 9999,
          }}
        />
      )}

      <ModalView isOpen={isOpen} onClose={onClose}>
        <div className={styles.verifyOtpContainer}>
          <div className={styles.verifyOtpHeader}>
            <h2>Verify OTP</h2>
            <button className={styles.closeBtn} onClick={onClose}>
              &times;
            </button>
          </div>

          <div className={styles.otpInfo}>
            <p>
              Please verify the OTP sent to{" "}
              <span className={styles.phoneNumber}>{displayNumber}</span>
            </p>
            <span className={styles.editLink} onClick={goToEditPhone}>
              EDIT
            </span>
          </div>

          {timeLeft > 0 ? (
            <p className={styles.otpExpiry}>OTP Expires in 1 min</p>
          ) : (
            <p>OTP expired</p>
          )}

          <div className={styles.otpInputs}>
            {[0, 1, 2, 3].map((_, index) => (
              <input
                key={index}
                type="text"
                maxLength={1}
                value={otp[index]}
                ref={(el: HTMLInputElement | null) => {
                  inputsRef.current[index] = el;
                }}
                onChange={(e) => handleInputChange(e, index, () => setError(""))}
                onKeyDown={(e) => handleKeyDown(e, index)}
              />
            ))}
          </div>
          <div className={styles.error}>{error}</div>

          <button
            className={styles.verifyOtpBtn}
            onClick={() => verifyOtp(getOtpString())}
            disabled={!isComplete || isVerifying}
          >
            VERIFY OTP
          </button>

          <p
            className={styles.resendOtp}
            style={{ cursor: canResend ? "pointer" : "not-allowed" }}
            onClick={canResend ? resendOtp : undefined}
          >
            {canResend
              ? "RESEND OTP"
              : `RESEND OTP IN ${formatTime(timeLeft)}`}
          </p>
        </div>
      </ModalView>
    </>
  );
}

export default VerifyOtp;
